
angular.module('directives').directive('openPopup', () => ({
    template: '',
    restrict: 'A',
    replace: false,
    link: (scope, element) => {

        element.on('click', () => {

            // show/hide popup on mobile
            if (window.deviceType === 'mobile') {

                if (element.hasClass('active')) {

                    element.removeClass('active');
                    element.next().removeClass('showBlock');

                } else {

                    element.addClass('active');
                    element.next().addClass('showBlock');

                }

            }

        });

    },
}));



// WEBPACK FOOTER //
// ./scripts/directives/open-popup.js